import { type MCPServerInfo } from '../../types';

const JenkinsServer: MCPServerInfo = {
  serverId: 'JENKINS',
  name: 'Jenkins',
  slug: 'jenkins',
  description: 'Jenkins MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/lanbaoshen/mcp-jenkins',
    commitSha: 'ca33214',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['jenkinsUrl', 'jenkinsUsername', 'jenkinsPassword'],
    properties: {
      jenkinsUrl: {
        type: 'string',
        description: 'The URL of the Jenkins server',
        sensitive: false
      },
      jenkinsUsername: {
        type: 'string',
        description: 'Jenkins Username',
        sensitive: false
      },
      jenkinsPassword: {
        type: 'string',
        description: 'Jenkins Password',
        sensitive: true
      },
      jenkinsTimeout: {
        type: 'number',
        description: 'Timeout (in seconds) for Jenkins API requests',
        sensitive: false,
        default: '5'
      },
      transport: {
        type: 'string',
        description: 'Transport protocol to use',
        sensitive: false,
        default: 'stdio'
      }
    }
  },
  deprecated: true
};

export default JenkinsServer;
